import React, { Component } from 'react'; 

class creatividad extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Concurso de Creatividad e Ingenio</h2>
              </header>
                <div className="containerjuego"> 
                    <div className="row-juego"> 
                      <h4>Consulta y realiza tu registro al 24° Concurso de Creatividad e Ingenio de Museo El Rehilete</h4>
                    </div>
                    <div>
                      <br></br>
                    </div>
                      <div className="row">
                        <div className="col-md-12">
                          <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Concurso_Creatividad.pdf" target="blank"> <img src="images/convocatoriacci.jpg" width="70%" alt='Convocatoria'/></a>
                          <h5>
                            
                          </h5>
                        </div>
                        </div>
                         <div className="row">
                        <div className="col-md-6">
                          <a href="https://x537xbtz.forms.app/formulario-de-registro-de-estudiantes" target="blank"> <img src="images/registrocci.jpg" width="70%" alt="Portada"/></a>
                          <h5>
                      
                          </h5>
                        </div>
                         <div className="col-md-6">
                          <a href="https://x537xbtz.forms.app/formulario-de-registro-de-estudiantes" target="blank"> <img src="images/registrocci.jpg" width="70%" alt="Portada"/></a>
                          <h5>
                      
                          </h5>
                        </div>
                        </div>
                        {/*<div className="col-md-4">
                          <a href="/rompecabezas" target=""> <img src="images/pic01.jpg" alt="Portada"/></a>
                          <h5>
                            Universo
                          </h5>
                        </div>
                        <div className="col-md-4">
                          <a href="/rompecabezas" target=""> <img src="images/pic01.jpg" alt="Portada"/></a>
                          <h5>
                            Sopa de Letras
                          </h5>
                        </div> */}
                      </div>
                
            </div>
          </div>
        ); 
    } 
} 

export default creatividad;